import * as React from 'react'
import { PageProps } from '@logic'
import { AccountSettingsShared } from '@modules/profile/components/acc-settings-shared'

type Props = PageProps

export const GuestViewAccountSettings = (props: Props) => {
    return <AccountSettingsShared {...props} forGuest={true} />
}
